import { FC } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert, { AlertColor } from "@mui/material/Alert";

interface PropsErrorAlert {
  open: boolean;
  onClose: (event?: React.SyntheticEvent | Event, reason?: string) => void; // Tipado más preciso
  message: string;
  severity: AlertColor | undefined;
}

const AlertC: FC<PropsErrorAlert> = ({ open, onClose, message, severity, ...rest }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        severity={severity}
        elevation={6}
        variant="filled"
        onClose={onClose}
        {...rest}
        sx={{
          width: '100%',
          fontSize: "1.6rem",
          alignItems: 'center'
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default AlertC;